import React, { useState } from 'react';
import { Program } from '../types';
import { LocationIcon, UsersIcon } from './Icons';

// Cause-specific branding — exact match to portal & mobile app
// Colors from portal: theme.css (.empoweringPeople, .basicNeeds, .climateChange)
// Icons from mobile app: GFTL.svg font (Basic-Needs, Empowering-People, Climate-Change)
const CAUSE_THEME: Record<string, { badgeBg: string; iconBg: string; textColor: string; icon: React.ReactNode }> = {
  'Basic Needs': {
    badgeBg: 'rgba(255, 224, 169, 0.8)',   // portal: .basicNeeds background
    iconBg: '#ffe0a9',                       // portal: .basicNeeds i background
    textColor: '#081E1D',                    // portal: var(--PRIMARY)
    icon: (
      <svg width="16" height="16" viewBox="0 0 1024 1024" fill="#081E1D">
        <path d="M495.624 897.281l-385.859-258.111c-10.55-7.070-24.824-4.214-31.881 6.354s-4.206 24.868 6.344 31.936l398.64 266.655c7.722 5.181 17.814 5.181 25.536 0l398.502-266.677c10.55-7.070 13.4-21.368 6.344-31.936-4.436-6.656-11.722-10.248-19.146-10.248-4.368 0-8.804 1.268-12.734 3.892l-385.746 258.135zM808.398 618.73v-94.312h94.15c12.688 0 22.986-10.316 22.986-23.026s-10.298-23.024-22.986-23.024h-94.15v-94.312c0-12.71-10.298-23.024-22.986-23.024s-22.984 10.314-22.984 23.024v94.312h-94.15c-12.688 0-22.986 10.314-22.986 23.024s10.298 23.026 22.986 23.026h94.15v94.312c0 12.708 10.296 23.024 22.984 23.024s22.986-10.316 22.986-23.024zM945.984 179.564c-4.276 6.402-11.448 10.246-19.124 10.246h-57.418l-220.294 219.362c-4.298 4.282-10.138 6.7-16.206 6.7h-0.068c-6.092 0-11.93-2.464-16.228-6.794l-217.582-219.268h-57.326c-7.678 0-14.85-3.844-19.124-10.246-4.276-6.4-5.058-14.506-2.116-21.598 52.798-127.536 175.978-209.966 313.8-209.966s261.002 82.408 313.8 209.966c2.942 7.116 2.138 15.22-2.114 21.598zM633.058 360.266l171.196-170.478h-340.37l169.174 170.478zM634.298-5.95c-107.274 0-204.272 57.724-255.876 149.71h511.752c-51.602-91.962-148.602-149.71-255.876-149.71zM188.147 141.79h77.967c12.688 0 22.986-10.316 22.986-23.026s-10.298-23.024-22.986-23.024h-100.953c-12.688 0-22.986 10.314-22.986 23.024v309.92h-45.19c-12.688 0-22.986 10.314-22.986 23.024v114.090c0 12.732 10.298 23.026 22.986 23.026h135.73c12.688 0 22.986-10.316 22.986-23.026 0-41.79 33.926-75.776 75.646-75.776 41.718 0 75.644 33.986 75.644 75.776 0 12.71 10.298 23.026 22.986 23.026h135.73c12.688 0 22.986-10.316 22.986-23.026v-114.090c0-12.71-10.298-23.024-22.986-23.024h-45.19v-49.62c0-12.71-10.296-23.026-22.984-23.026s-22.986 10.316-22.986 23.026v72.644c0 12.71 10.298 23.026 22.986 23.026h45.188v68.038h-91.942c-10.78-56.204-60.222-98.8-119.432-98.8-59.212 0-108.654 42.596-119.434 98.8h-91.943v-68.038h45.19c12.688 0 22.986-10.316 22.986-23.026v-309.918z"/>
      </svg>
    ),
  },
  'Empowering People': {
    badgeBg: 'rgba(228, 222, 255, 0.8)',    // portal: .empoweringPeople background
    iconBg: '#e4deff',                       // portal: .empoweringPeople i background
    textColor: '#081E1D',                    // portal: var(--PRIMARY)
    icon: (
      <svg width="16" height="16" viewBox="0 0 1024 1024" fill="#081E1D">
        <path d="M512.15 835.981c12 0 21.738 9.784 21.738 21.84v68.338c0 12.056-9.738 21.84-21.738 21.84-11.998 0-21.736-9.784-21.736-21.84v-68.338c0-12.056 9.738-21.84 21.736-21.84zM652.324 204.1h-178.026c-11.998 0-21.736-9.784-21.736-21.84s9.738-21.84 21.736-21.84h156.29v-49.71c0-65.63-53.148-119.030-118.466-119.030-65.32 0-118.468 53.4-118.468 119.030v71.55c0 12.056-9.738 21.84-21.736 21.84-12 0-21.738-9.784-21.738-21.84v-71.55c0-89.72 72.646-162.71 161.942-162.71 89.294 0 161.94 72.99 161.94 162.71v71.55c0 12.056-9.738 21.84-21.738 21.84zM239.134 753.242c8.498-8.516 8.498-22.342 0-30.882-4.24-4.258-9.804-6.398-15.368-6.398-5.566 0-11.13 2.14-15.368 6.398l-48.344 48.573c-8.477 8.518-8.477 22.343 0 30.882 8.477 8.518 22.237 8.518 30.736 0l48.344-48.574zM104.317 469.874h-66.58c-11.999 0-21.737-9.786-21.737-21.842s9.738-21.84 21.737-21.84h66.58c11.999 0 21.737 9.784 21.737 21.84s-9.738 21.842-21.737 21.842zM785.268 753.234l47.864 48.093c8.478 8.518 22.238 8.518 30.736 0 8.5-8.518 8.5-22.343 0-30.882l-47.864-48.093c-4.238-4.258-9.804-6.398-15.368-6.398s-11.13 2.14-15.368 6.398c-8.5 8.518-8.5 22.344 0 30.882zM987.568 469.874h-67.602c-11.998 0-21.736-9.786-21.736-21.842s9.738-21.84 21.736-21.84h67.602c12 0 21.738 9.784 21.738 21.84s-9.738 21.842-21.738 21.842zM303.77 239.050c-114.685 115.23-114.685 302.708 0 417.936 114.662 115.231 301.254 115.231 415.938 0 114.684-115.228 114.684-302.706 0-417.936-4.24-4.26-9.804-6.4-15.368-6.4-5.566 0-11.13 2.14-15.368 6.4-8.5 8.518-8.5 22.342 0 30.882 97.728 98.194 97.728 257.956 0 356.15-97.73 98.196-256.736 98.196-354.466 0-97.73-98.194-97.73-257.956 0-356.15 8.5-8.518 8.5-22.342 0-30.882-8.478-8.518-22.258-8.518-30.736 0z"/>
      </svg>
    ),
  },
  'Climate Change': {
    badgeBg: 'rgba(195, 237, 220, 0.8)',    // portal: .climateChange background
    iconBg: '#c3eddc',                       // portal: .climateChange i background
    textColor: '#081E1D',                    // portal: var(--PRIMARY)
    icon: (
      <svg width="16" height="16" viewBox="0 0 1024 1024" fill="#081E1D">
        <path d="M12 448c0 275.7 224.3 500 500 500 275.674 0 499.974-224.3 499.974-500.026 0-227.004-153.138-425.856-372.41-483.548-13.494-3.538-27.316 4.524-30.88 18.018-3.538 13.494 4.524 27.316 18.018 30.88 197.084 51.854 334.732 230.618 334.732 434.676 0 247.826-201.608 449.459-449.434 449.459s-449.459-201.633-449.459-449.459c0-247.826 201.633-449.46 449.459-449.46 13.95 0 25.27-11.32 25.27-25.27 0-13.948-11.32-25.27-25.27-25.27-275.7 0-500 224.3-500 500zM229.022 233.176h150.434c25.902 0 46.952 21.050 46.952 46.952s-21.076 46.954-46.952 46.954h-159.026c-53.751 0-97.494 43.742-97.494 97.492s43.743 97.494 97.494 97.494c25.902 0 46.952 21.050 46.952 46.952s-21.076 46.952-46.952 46.952h-24.007c-13.949 0-25.27 11.322-25.27 25.27 0 13.95 11.321 25.27 25.27 25.27h24.007c53.75 0 97.492-43.742 97.492-97.492s-43.742-97.494-97.492-97.494c-25.903 0-46.953-21.050-46.953-46.952s21.076-46.952 46.953-46.952h159.026c53.75 0 97.494-43.744 97.494-97.494s-43.744-97.492-97.494-97.492h-150.434c-13.95 0-25.272 11.32-25.272 25.27s11.322 25.27 25.272 25.27zM584.288 350.908h172.218c25.878 0 46.954-21.050 46.954-46.952 0-13.948 11.32-25.27 25.27-25.27 13.948 0 25.27 11.322 25.27 25.27 0 53.75-43.744 97.494-97.494 97.494h-172.218c-25.876 0-46.952 21.050-46.952 46.952s21.050 46.952 46.952 46.952h79.046c53.75 0 97.494 43.744 97.494 97.494 0 25.876 21.050 46.952 46.952 46.952 13.95 0 25.27 11.322 25.27 25.27 0 13.95-11.32 25.27-25.27 25.27-53.75 0-97.492-43.742-97.492-97.492 0-25.878-21.052-46.952-46.954-46.952h-79.046c-53.75 0-97.492-43.744-97.492-97.494s43.742-97.494 97.492-97.494zM627.206 835.942c13.95 0 25.272-11.321 25.272-25.27 0-53.75-43.744-97.494-97.494-97.494h-91.984c-53.75 0-97.494 43.744-97.494 97.494 0 13.949 11.322 25.27 25.272 25.27 13.948 0 25.27-11.321 25.27-25.27 0-25.902 21.074-46.952 46.952-46.952h91.984c25.902 0 46.952 21.075 46.952 46.952 0 13.949 11.322 25.27 25.27 25.27z"/>
      </svg>
    ),
  },
  'Emergency Aid': {
    badgeBg: 'rgba(249, 197, 197, 0.8)',
    iconBg: '#F9C5C5',
    textColor: '#081E1D',
    icon: (
      <svg width="16" height="16" viewBox="0 0 1024 1024" fill="#081E1D">
        <path d="M94.802 26.424c-6.509 0-12.676 2.97-16.744 8.054-24.774 30.996-46.251 64.686-63.83 100.146-1.456 2.948-2.227 6.196-2.227 9.464v473.688c0 3.29 0.749 6.536 2.227 9.462 17.708 35.718 39.377 69.642 64.408 100.852 4.068 5.064 10.214 8.012 16.723 8.012h182.262l37.172 85.277c0.042 0.107 0.086 0.214 0.15 0.32l0.108 0.214c2.718 6.131 7.964 10.361 13.982 11.984 58.776 23.968 121.022 36.102 185.088 36.102s128.11-12.497 187.658-37.128c6.66-2.756 11.198-8.481 12.676-15.018l41.24-94.593c2.87-6.6 2.226-14.206-1.734-20.23-3.962-6.024-10.686-9.656-17.902-9.656h-333.54c-11.82 0-21.412 9.57-21.412 21.362s9.592 21.364 21.412 21.364h300.888l-26.466 60.689c-51.818 20.23-106.548 30.463-162.82 30.463s-111.452-10.339-163.462-30.719l-39.378-90.319c-3.404-7.798-11.112-12.84-19.634-12.84h-185.881c-19.443-25.25-36.551-52.338-50.94-80.664v-463.562c14.282-28.090 31.198-54.942 50.426-80h817.737c17.366 22.622 32.868 46.718 46.166 71.798v479.99c-13.448 25.314-29.12 49.624-46.68 72.46h-90.552c-11.82 0-21.412 9.57-21.412 21.362s9.592 21.362 21.412 21.362h100.98c6.51 0 12.656-2.948 16.724-8.01 22.996-28.668 43.168-59.666 59.976-92.094 1.562-3.032 2.398-6.408 2.398-9.804v-490.5c0-3.418-0.814-6.772-2.398-9.806-16.68-32.192-36.68-62.932-59.42-91.408-4.068-5.084-10.234-8.054-16.744-8.054v-0.022h-838.636z"/>
      </svg>
    ),
  },
};

// Get cause theme, with fallback
const getCauseTheme = (causeTitle?: string) => {
  if (!causeTitle) return { badgeBg: 'rgba(195, 237, 220, 0.2)', iconBg: '#c3eddc', textColor: '#081E1D', icon: null };
  return CAUSE_THEME[causeTitle] || { badgeBg: 'rgba(195, 237, 220, 0.2)', iconBg: '#c3eddc', textColor: '#081E1D', icon: null };
};

// Default program placeholder — beautiful gradient with image icon
const ProgramPlaceholder: React.FC<{ causeTheme: ReturnType<typeof getCauseTheme> }> = ({ causeTheme }) => (
  <div className="program-card__placeholder" style={{ background: `linear-gradient(135deg, ${causeTheme.iconBg}44 0%, ${causeTheme.iconBg}88 50%, ${causeTheme.iconBg}bb 100%)` }}>
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke={causeTheme.textColor} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" opacity="0.25">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  </div>
);

// Default org logo placeholder — styled circle with first letter
const OrgLogoPlaceholder: React.FC<{ name: string }> = ({ name }) => (
  <div className="program-card__org-logo program-card__org-logo--placeholder">
    {name.charAt(0).toUpperCase()}
  </div>
);

// Expandable description with See more / See less
const DESC_CHAR_LIMIT = 150;

const ExpandableDescription: React.FC<{ text: string }> = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const needsTruncation = text && text.length > DESC_CHAR_LIMIT;

  if (!text) return null;

  return (
    <div className="program-card__description">
      <p className="program-card__description-text">
        {expanded || !needsTruncation
          ? text
          : `${text.slice(0, DESC_CHAR_LIMIT).trimEnd()}...`}
      </p>
      {needsTruncation && (
        <span
          className={`program-card__see-more-btn${expanded ? ' expanded' : ''}`}
          onClick={() => setExpanded(!expanded)}
          role="button"
          tabIndex={0}
        >
          {expanded ? 'See less' : 'See more'}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="program-card__see-more-arrow">
            <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      )}
    </div>
  );
};

interface ProgramCardProps {
  program: Program;
}

const ProgramCard: React.FC<ProgramCardProps> = ({ program }) => {
  const [imageError, setImageError] = React.useState(false);
  const [orgLogoError, setOrgLogoError] = React.useState(false);
  
  // Calculate progress percentage
  const currentAmount = program.currentAmount || 0;
  const progressPercentage = Math.min((currentAmount / program.goalAmount) * 100, 100);

  // Cause theme
  const causeTheme = getCauseTheme(program.cause?.title);
  
  // Get primary image - handle both string array and object array formats
  const getImageUrl = (media: any): string | null => {
    if (!media) return null;
    if (typeof media === 'string') return media;
    if (media.url) return media.url;
    return null;
  };
  
  const primaryImage = !imageError && program.media && program.media.length > 0 
    ? getImageUrl(program.media[0])
    : null;
  
  // Get organization logo - handle null case
  const orgLogo = !orgLogoError && program.organisation?.logo 
    ? program.organisation.logo 
    : null;
  const hasOrgLogo = !!orgLogo;
    
  // Format currency
  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <div className="program-card">
      {/* Media Section */}
      <div className="program-card__media">
        {primaryImage ? (
          <img 
            src={primaryImage} 
            alt={program.title}
            className="program-card__image"
            onError={() => setImageError(true)}
          />
        ) : (
          <ProgramPlaceholder causeTheme={causeTheme} />
        )}
        {program.cause && (
          <span 
            className="program-card__badge"
            style={{ backgroundColor: causeTheme.badgeBg, color: causeTheme.textColor }}
          >
            {causeTheme.icon && (
              <span className="program-card__badge-icon" style={{ backgroundColor: causeTheme.iconBg }}>
                {causeTheme.icon}
              </span>
            )}
            {program.cause.title}
          </span>
        )}
      </div>
      
      {/* Content Section */}
      <div className="program-card__content">
        {/* Organisation */}
        {program.organisation && (
          <div className="program-card__org">
            {hasOrgLogo ? (
              <img 
                src={orgLogo!} 
                alt={program.organisation.title}
                className="program-card__org-logo"
                onError={() => setOrgLogoError(true)}
              />
            ) : (
              <OrgLogoPlaceholder name={program.organisation.title} />
            )}
            <span className="program-card__org-name">{program.organisation.title}</span>
          </div>
        )}
        
        {/* Title */}
        <h1 className="program-card__title">{program.title}</h1>
        
        {/* Location */}
        {(program.city || program.country) && (
          <div className="program-card__location">
            <LocationIcon />
            <span>{[program.city, program.country].filter(Boolean).join(', ')}</span>
          </div>
        )}
        
        {/* Description */}
        <ExpandableDescription text={program.description} />
        
        {/* Progress Section */}
        <div className="progress-section">
          <div className="progress-header">
            <span className="progress-amount">{formatCurrency(currentAmount)}</span>
            <span className="progress-goal">of {formatCurrency(program.goalAmount)} goal</span>
          </div>
          
          <div className="progress-bar">
            <div 
              className="progress-bar__fill" 
              style={{ width: `${progressPercentage}%`, backgroundColor: causeTheme.iconBg }}
            />
          </div>
          
          <div className="progress-stats">
            <div className="progress-stat">
              <span className="progress-stat__value">{Math.round(progressPercentage)}%</span>
              <span className="progress-stat__label">Funded</span>
            </div>
            {program.donationCount !== undefined && (
              <div className="progress-stat">
                <UsersIcon />
                <span className="progress-stat__value">{program.donationCount}</span>
                <span className="progress-stat__label">Donors</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
